import { NewviewOaBaseApi } from "./NewviewOaBaseApi";


export class AttendanceSigninApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'attendanceSignin'
  }


  /**
   * 考勤打卡统计
   * @param month 
   * @returns 
   */
  public getSignList(month, userIds) {
    return this.send({ month: month, userIds: userIds }, "getSignList", this.Methods.GET)
  }

  /**
   * 根据条件删除
   * @param params
   */
  public deleteByParams(params) {
    return this.send(params, "deleteByParams", this.Methods.POST)
  }




  /**
   * 导出
   * @returns 
   */
  public excel(params) {
    return this.download(params, "excel")
  }



}